<mat-form-field fxFlexFill  >
      
    <input matInput 
    id="findArticle"
    [placeholder]="placeholder"   
    
    [matAutocomplete]="auto"
    [name]= "name"
    [(ngModel)]="parentVal" 
    (ngModelChange)="onModif($event)" 

    #newHero
    (keyup.enter)="keyenter(newHero.value)"
    (blur)="keyblur(newHero.value)"
    

    (focus)="focusFunction()"

   >
   <button mat-button *ngIf="parentVal" matSuffix mat-icon-button aria-label="Clear" (click)="parentVal=''">
    <mat-icon>close</mat-icon>
  </button>
  
    <mat-autocomplete [displayWith]="setTextInput" (optionSelected)="onSelectionChanged($event)" autoActiveFirstOption  #auto="matAutocomplete">
      <mat-option *ngIf="!exist" class="is-loading"><mat-spinner diameter="50"></mat-spinner></mat-option>
      <div *ngIf="exist"> 
      <mat-table  #table [dataSource]="dataSource" matSort class="example-table">
        <div *ngFor="let item of tbrecherche">
          <ng-container [matColumnDef]="item.TableRD_Champs">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ item.TableRD_Des }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div >{{ row[item.TableRD_Champs] }}</div>
            </mat-cell>
          </ng-container>
        </div>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-option   *matRowDef="let row; columns: displayedColumns" [value]="row" >
          <mat-row></mat-row>
        </mat-option>
      </mat-table>
     </div>
    </mat-autocomplete>
  </mat-form-field>
